<template>
  <div
    class="dataBaseDetails"
    v-if="this.language == 'eng'"
    style="font-family: 'Times New Roman', Times, serif"
  >
    <Pic-top></Pic-top>
    <div class="dataBaseDetailTop">
      <div class="section eng_section">
        <div class="section_left">
          <span @click="handleRouter(1)">Home</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="exhibition"
            >Regong Art Works</router-link
          >
          <span>&nbsp;>&nbsp;</span>
          <span @click="goCategory">{{ eng_typeName }}</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ item.englishName }}</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <Common-detail></Common-detail>
    <div class="contact">
      <el-popover placement="left" width="240" trigger="hover">
        <div class="tel">Contact Number：{{templeContact}}</div>
        <div class="tel">Email：{{templeEmail}}</div>
        <div class="mobile" slot="reference">
          <div class="message">
            <img src="../../assets/exhibitionsale/phone.png" alt="" />
            <div>Contact art studio</div>
          </div>
        </div>
      </el-popover>
    </div>
  </div>
  <div class="dataBaseDetails" v-else-if="this.language == 'en'">
    <Pic-top></Pic-top>
    <div class="dataBaseDetailTop">
      <div class="section eng_section">
        <div class="section_left">
          <span @click="handleRouter(1)"> ངོ་བྱང་།</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="exhibition"
            >རེབ་གོང་སྒྱུ་རྩལ་གྱི་གྲངས་མཛོད་བརྩམས་ཆོས།</router-link
          >
          <span>&nbsp;>&nbsp;</span>
          <span @click="goCategory">{{ za_typeName }}</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ item.zangName }}</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <Common-detail></Common-detail>
    <div class="contact">
      <el-popover placement="left" width="240" trigger="hover">
        <div class="tel">འབྲེལ་གཏུགས་ཨང་གྲངས།：{{templeContact}}</div>
        <div class="tel">སྦྲགས་ཡིག：{{templeEmail}}</div>
        <div class="mobile" slot="reference">
          <div class="message">
            <img src="../../assets/exhibitionsale/phone.png" alt="" />
            <div>འབྲེལ་གཏུག</div>
          </div>
        </div>
      </el-popover>
    </div>
  </div>
  <div class="dataBaseDetails" v-else>
    <Pic-top></Pic-top>
    <div class="dataBaseDetailTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">首页</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="exhibition">热贡作品展</router-link>
          <span>&nbsp;>&nbsp;</span>
          <span @click="goCategory">{{ typeName }}</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">{{ item.chineseName }}</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <Common-detail></Common-detail>
    <div class="contact">
      <el-popover placement="left" width="240" trigger="hover">
        <div class="tel">联系电话：{{templeContact}}</div>
        <div class="tel">邮件：{{templeEmail}}</div>
        <div class="mobile" slot="reference">
          <div class="message">
            <img src="../../assets/exhibitionsale/phone.png" alt="" />
            <div>联系画院</div>
          </div>
        </div>
      </el-popover>
    </div>
  </div>
</template>
<script>
import PicTop from "../../components/picsTop.vue";
import CommonDetail from "../../components/commonDetail.vue";
import { productGet } from "../../api/management.js";
export default {
  components: {
    PicTop,
    CommonDetail,
  },
  data() {
    return {
      language: this.$store.state.language,
      url: process.env.VUE_APP_WEB_URL,
      id: this.$route.query.id,
      item: {},
      typeName: "", //分类名
      za_typeName: "", //分类名
      eng_typeName: "", //分类名
      category: null,
      templeContact:'',
      templeEmail: '',
    };
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  created() {
    this.getProductGet();
  },
  mounted() {
    new this.$wow.WOW().init();
    this.getPCorMobile();
  },
  methods: {
    async getProductGet() {
      const res = await productGet(this.id);
      this.item = res.data;
      this.category = res.data.category;
      let category = res.data.category;
      if(res.data.templeContact) {
        this.templeContact = res.data.templeContact;
      } else {
        this.templeContact = '18997193666';
      }
      if(res.data.templeEmail) {
        this.templeEmail = res.data.templeEmail;
      } else {
        this.templeEmail = 'regong_art_db@163.com';
      }
      if (category == 1) {
        this.typeName = "唐卡";
        this.za_typeName = " ཐང་ག ";
        this.eng_typeName = "Thangka";
      } else if (category == 2) {
        this.typeName = "泥塑";
        this.eng_typeName = "Clay sculpture";
        this.za_typeName = "འཇིམ་བཟོ། ";
      } else if (category == 3) {
        this.typeName = "壁画";
        this.eng_typeName = "Mural";
        this.za_typeName = " ལྡེབས་རིས།";
      } else if (category == 4) {
        this.typeName = "堆绣";
        this.eng_typeName = "Pile embroidery";
        this.za_typeName = " དྲས་དྲུབ།";
      } else if (category == 5) {
        this.eng_typeName = "Paintings";
        this.typeName = "彩绘";
        this.za_typeName = "ཚོན་རིས།";
      } else if (category == 6) {
        this.typeName = "其他";
        this.eng_typeName = "Other";
        this.za_typeName = " གཞན་དག ";
      }
    },
    getPCorMobile() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.width = 320;
        this.height = 380;
      } else {
        this.width = 460;
        this.height = 610;
      }
    },
    goCategory() {
      this.$router.push({
        path: "/exhibitionWork",
        query: { category: this.category },
      });
      // this.$router.back()
    },
    handleRouter(num) {
      this.$store.commit("changeNum", num);
      this.$router.push("/index");
    },
  },
};
</script>
<style lang="scss" scoped>
.dataBaseDetails {
  background: url("../../assets/newImage/index/could_right.png") no-repeat right
    bottom;
  background-position: 100% 100%;
  background-size: 7%;
  .dataBaseDetailTop {
    border-bottom: 1px solid #f4f5f6;
    position: relative;
    .section {
      padding: 50px 0;
      font-size: 18px;
      position: relative;
      .section_left {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        z-index: 88;
        .color {
          color: #ed201a;
        }
        span {
          cursor: pointer;
        }
      }
    }
    .cloudLeft {
      position: absolute;
      top: 50%;
      left: 0;
      z-index: 1;
      width: 125px;
      height: 95px;
    }
  }
  .contact {
    z-index: 99;
    color: #fff;
    position: fixed;
    right: 2%;
    bottom: 20%;
    .made,
    .mobile {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      text-align: center;
      width: 110px;
      height: 110px;
      border-radius: 100%;
      background-color: #99131a;
      font-size: 12px;
      margin-bottom: 20px;
      box-shadow: 0 0 10px #99131a;
      border: none;
      img {
        width: 32px;
        margin-bottom: 6px;
      }
    }
  }
}
@media (max-width: 768px) {
  .dataBaseDetails {
    background-size: 15%;
    padding-bottom: 1rem;
    position: relative;
    .dataBaseDetailTop {
      .section {
        background: url("../../assets/newImage/index/could_left.png") no-repeat
          top left;
        background-position: 0 50%;
        background-size: 15%;
        padding: 0.6rem 0.2rem;
        font-size: 0.3rem;
        .section_left {
          left: 0.2rem;
        }
      }
      .eng_section {
        font-size: 0.26rem;
      }
    }
    .contact {
      z-index: 2001;
      bottom: 35%;
      right: 1%;
      .made,
      .mobile {
        width: 1.7rem;
        height: 1.7rem;
        padding: 0.2rem;
        margin-bottom: 0.2rem;
        img {
          width: 0.4rem;
        }
        div {
          font-size: 0.2rem;
        }
      }
    }
  }
}
</style>


